import { assetAt } from 'utils/assets';

export const pointId = point => `${point.type}_${point.id}`;

export const pointIcon = point => {
  let name;
  if (point.type === 'point') {
    name = `termite`;
  } else {
    name = commentIcon(point.icon);
  }

  return assetAt(`images/pins/png/${name}.png`);
};

export const staticIconUrl = icon => assetAt(`images/icons/${icon}.svg`);
export const staticIconUrlPNG = icon => assetAt(`images/icons/${icon}.png`);

function commentIcon(icon) {
  switch (icon.toUpperCase()) {
    case 'INFO':
      return 'information';
    case 'EXCLAMATION':
      return 'exclamation';
    case 'QUESTION':
      return 'interogation';
    case 'CONE':
      return 'works';
    case 'CAMERA':
      return 'camera';
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/reducers/point.js